/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Ladda = require('ladda');
var Radio = require('backbone.radio');

var SecCompRegFormView = require('./SecCompRegFormView');
var tmplSecIntCompRegNewView = require('../templates/SecIntCompRegNewView.hbs');
var BreadcrumbView = require('common/views/BreadcrumbView');
var SubmitUserComplianceRegistration = require('../services/SubmitUserComplianceRegistration');

module.exports = Marionette.LayoutView.extend({
  template: tmplSecIntCompRegNewView,

  className: 'sec-int-compliance-registration-new-view container-fluid',

  ui: {
    headerBar: '.header-bar',
    breadcrumb: '.breadcrumb-container',
    complianceRegistrationForm: '.compliance-registration-form-container',
    submit: '.btn-submit'
  },

  regions: {
    headerBar: '@ui.headerBar',
    breadcrumb: '@ui.breadcrumb',
    complianceRegistrationForm: '@ui.complianceRegistrationForm'
  },

  events: {
    'click @ui.submit': 'onClickSubmit'
  },

  onBeforeShow: function() {
    this.showChildView(
      'breadcrumb',
      new BreadcrumbView({
        breadcrumbs: [
          {
            link: '#sec/compliance-registration-search',
            text: 'Home'
          },
          {
            text: 'New Compliance Registration'
          }
        ]
      })
    );

    this.complianceRegistrationForm = new SecCompRegFormView({
      model: this.model
    });

    this.showChildView('complianceRegistrationForm', this.complianceRegistrationForm);
  },

  onClickSubmit: function(e) {
    e.preventDefault();

    this.validate().done(
      function() {
        var laddaContext = Ladda.create(this.ui.submit.get(0));
        laddaContext.start();
        var formData = this.getFormData();
        formData.isPaid = 1;
        formData.isInternal = 1;
        SubmitUserComplianceRegistration(formData)
          .done(function() {
            Radio.channel('navigate').trigger('show:int:sc:comp-reg-search');
          })
          .fail(function() {
            laddaContext.stop();
          });
      }.bind(this)
    );
  },

  validate: function() {
    return this.ui.complianceRegistrationForm.parsley().whenValidate();
  },

  getFormData: function() {
    var formData = this.complianceRegistrationForm.getFormData();
    return formData;
  }
});
